/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.productSizeSection.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/ProductSizeSection/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
